<ion-content class="m-modal">
  <ion-grid class="ion-padding">
    <ion-row class="m-modal-header">
      <ion-col size="12" size-md="11">
        <h4 class="m-modal-title">{{ modalTitle }}</h4>
      </ion-col>
      <ion-col size="6" size-md="1" class="ion-text-center">
        <ion-button color="tech-blue" class="m-modal-icon" fill="clear" (click)="dismiss()">
          <ion-icon slot="icon-only" name="close"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row class="m-modal-body">
      <ion-col size="12">
        <ion-list class="m-modal-field-list list-color-custom">
          <p class="insights-full" [innerHTML]="resumeDetail"></p>
        </ion-list>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>